module.exports = __webpack_public_path__ + "static/img_9840-243c0c8edfff7c17d85873837fe85115.webp";